// FIXED MultiItemSelectModal.js - Remove old destructuring logic
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Chip,
    IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { formatDate } from '../../utils/dateUtils';
import CloseIcon from '@mui/icons-material/Close';
import { MODAL_BORDER_RADIUS } from '../../utils/dateUtils';

const MultiItemSelectModal = ({
    open,
    onClose,
    onItemClick,
    onAddNewItem,
    items,          // Individual prop (not from multiItemSelectState)
    date,           // Individual prop (not from multiItemSelectState)
    readOnly,       // Individual prop (not from multiItemSelectState)
    contentTypeColors,
    style           // For z-index
}) => {

    // Helper function to get display name with Random prefix
    const getDisplayName = (item) => {
        const baseName = item.contentName || item.contentId;
        if (item.contentType === 'RandomSimulation') {
            return `Random - ${baseName}`;
        }
        return baseName;
    };

    // Helper function to get content type display
    const getContentTypeDisplay = (contentType) => {
        switch (contentType) {
            case 'RandomSimulation':
                return 'Simulation';
            case 'Simulation':
                return 'Simulation';
            case 'Course':
                return 'Course';
            default:
                return contentType;
        }
    };

    // Helper function to get color
    const getItemColor = (contentType) => {
        if (contentType === 'RandomSimulation') {
            return contentTypeColors['Simulation'] || '#999';
        }
        return contentTypeColors[contentType] || '#999';
    };

    return (
        <Box sx={{ position: 'relative' }}>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: MODAL_BORDER_RADIUS,
                        overflow: 'visible',
                        ...style // Apply z-index
                    },
                    sx: { bgcolor: 'background.default' }
                }}
            >
                {open && (
                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 0,
                            top: -45,
                            bgcolor: 'background.default',
                            boxShadow: 2,
                            '&:hover': {
                                bgcolor: 'background.default',
                                opacity: 0.9
                            },
                            width: 40,
                            height: 40,
                            zIndex: 5
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
                <DialogTitle>
                    Select Item to Edit
                    <Typography variant="subtitle2" color="textSecondary">
                        {date ? formatDate(date) : ''}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ my: 1 }}>
                        {items?.map(item => (
                            <Button
                                key={item.id}
                                fullWidth
                                variant="outlined"
                                sx={{
                                    mb: 1,
                                    borderLeft: `6px solid ${getItemColor(item.contentType)}`,
                                    justifyContent: 'flex-start',
                                    textAlign: 'left',
                                    borderRadius: '8px',
                                    opacity: readOnly ? 0.8 : 1,
                                    bgcolor: 'white',
                                    '&:hover': { bgcolor: 'white' }
                                }}
                                onClick={() => onItemClick(item)}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                                    <Typography variant="h6" sx={{ textTransform: 'none' }}>
                                        {getDisplayName(item)}
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                        <Chip
                                            label={getContentTypeDisplay(item.contentType)}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                fontSize: '0.75rem',
                                                bgcolor: getItemColor(item.contentType) + '20',
                                                borderColor: getItemColor(item.contentType)
                                            }}
                                        />
                                        {readOnly && (
                                            <Typography variant="caption" color="textSecondary">
                                                (View only - past date)
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            </Button>
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions>
                    {!readOnly && (
                        <Button
                            onClick={onAddNewItem}
                            color="primary"
                            variant="contained"
                            startIcon={<AddIcon />}
                        >
                            Add New Item
                        </Button>
                    )}
                    <Button onClick={onClose} variant="contained" color="warning">
                        {readOnly ? 'Close' : 'Cancel'}
                    </Button>
                </DialogActions>
                </Dialog>
        </Box>
    );
};

export default MultiItemSelectModal;